import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getCustomerReportsRequest = () => ({
  type: 'GET_CUSTOMER_REPORTS_REQUEST',
})

export const getCustomerReportsSuccess = (data) => ({
  type: 'GET_CUSTOMER_REPORTS_SUCCESS',
  data,
})

export const getCustomerReportsFailure = (error) => ({
  type: 'GET_CUSTOMER_REPORTS_FAILURE',
  error,
})

export const getCustomerReports = (startDate, endDate) => {
  return (dispatch) => {
    dispatch(getCustomerReportsRequest())

    fetch(
      `${URL.BASE_URL + URL.END_POINT.customerreports}?startDate=${startDate}&endDate=${endDate}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          USERID: localStorage.getItem('USERID'),
          Authorization: `Bearer token=${localStorage.getItem('token')}`,
        },
      },
    )
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getCustomerReportsSuccess(data))
      })
      .catch((error) => {
        dispatch(getCustomerReportsFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

const initialCustomerState = {
  customerReportsData: [],
  headersData: [],
  rowsData: [],
  loadingCustomerReportsData: false,
  errorCustomerReportsData: null,
}

export const customerReportsReducer = (state = initialCustomerState, action) => {
  switch (action.type) {
    case 'GET_CUSTOMER_REPORTS_REQUEST':
      return {
        ...state,
        loadingCustomerReportsData: true,
        errorCustomerReportsData: null,
      }
    case 'GET_CUSTOMER_REPORTS_SUCCESS':
      return {
        ...state,
        customerReportsData: action.data.data,
        headersData: action.data.headers,
        rowsData: action.data.rows,
        loadingCustomerReportsData: false,
        errorCustomerReportsData: null,
      }
    case 'GET_CUSTOMER_REPORTS_FAILURE':
      return {
        ...state,
        loadingCustomerReportsData: false,
        errorCustomerReportsData: action.error,
      }
    default:
      return state
  }
}
